import { CommonModule } from '@angular/common';
import { Component, Input, input, output, model, inject } from '@angular/core';
import { Subject } from 'rxjs';

import { FormsModule } from '@angular/forms';
import { NgbHighlight, NgbPaginationModule, NgbAlertModule, NgbDatepickerModule, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { NgxPaginationModule } from 'ngx-pagination';
import { ActionType, HeaderColumns, TableRequest } from 'src/app/model/table.model';

import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { AuthPermissionDirective } from 'src/app/directive/auth/auth-permission.directive';
import { Router } from '@angular/router';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { NgSelectModule } from '@ng-select/ng-select';


@Component({
    selector: 'app-table-view',
    imports: [NgbDatepickerModule, NgSelectModule, NgbAlertModule, CommonModule, NgMultiSelectDropDownModule, FormsModule, NgxPaginationModule, NgbPaginationModule, AuthPermissionDirective,
    ],
    templateUrl: './table-view.component.html',
    styleUrl: './table-view.component.css'
})
export class TableViewComponent {
  // Data for the table
  actionType = ActionType;
  actionColumnTypes = [
    ActionType.UPDATE,
    ActionType.DELETE,
    ActionType.COUPON,
    ActionType.STATS,
    ActionType.PAYMENT,
    ActionType.PUBLISH,
    ActionType.ARCHIVE,
  ];
  headerColumns = input<HeaderColumns[]>();
  tableData = input<any[]>();
  moduleName = input<string>();
  pageSizeTotalCount = input<number>();
  redirectLink = input<string>();
  model: NgbDateStruct;
  pageInfo = model<TableRequest>({
    pageSize: 10,
    currentPage: 1,
    totalCount: 100,
    sortColumn: '',
    sortOrder: 'asc',
    filteredValue: [],
    searchValue: '',
  });

  dropdownSettingsMulti = {
    singleSelection: false,
    idField: '_id',
    textField: 'name',
    itemsShowLimit: 1,
    enableCheckAll: false,
    allowSearchFilter: true,
    maxHeight:120
  };
  actionItems = input<ActionType[]>([]);
  disableActionItems = input<ActionType[]>([]);
  showTableFilter = input<boolean>(false);
  actionInfo = output<any>();
  @Input() filterFields;
  customSearchInput: Subject<string> = new Subject();
  router = inject(Router);

  pageSizeOptions: number[] = [10, 20, 50, 100];
  headerByKey = (_: any, item: HeaderColumns) => item.key;
  // For sorting
  sortColumn: string = '';
  sortOrder: 'asc' | 'desc' = 'asc';

  actionItem(type, value) {
    this.actionInfo.emit({
      type,
      value,
    })
  }

  hasInfoLink(): boolean {
    return this.actionItems().some((item) => String(item || "").toUpperCase() === this.actionType.INFO);
  }

  hasActionColumn(): boolean {
    return this.actionItems().some((item) =>
      this.actionColumnTypes.includes(String(item || "").toUpperCase() as ActionType),
    );
  }

  pageSize: number = 10;
  // For filtering
  searchText: string = '';

  ngOnInit() {
    // this.filteredData = this.data; // Initially set filtered data to all data
    this.pageSize = this.pageInfo().pageSize;
    this.customSearchInput.pipe(debounceTime(300), distinctUntilChanged()).subscribe(value => {
      //value will have your input
      this.pageInfo.update(item => ({ ...item, searchValue: value }));
    });

  }

  changeDatePickerSelection(event, obj: any) {
    obj.selectedValue = [event.year, event.month, event.day].join('-');
  }

  updatePageSelection() {
    this.pageInfo.update(item => ({ ...item, pageSize: this.pageSize }));

  }
  // Apply text filter
  applyFilter() {
    this.customSearchInput.next(this.searchText);
  }

  naviagetLink(link) {
    this.router.navigateByUrl(link);
  }

  // Sorting function
  sortData(column: string) {
    if (this.pageInfo().sortColumn === column) {
      // Toggle the sort order
      this.pageInfo.update(item => ({ ...item, sortOrder: item.sortOrder === 'asc' ? 'desc' : 'asc', currentPage: 1 }));
    } else {
      // Set the sort column and order to ascending by default
      this.pageInfo.update(item => ({ ...item, sortColumn: column, currentPage: 1, sortOrder: item.sortOrder === 'asc' ? 'desc' : 'asc' }));

    }
  }

  selectedPage(event) {
    this.pageInfo.update(item => ({ ...item, currentPage: event }));
  }

  // Method to reset all selections
  resetSelections() {
    this.filterFields.forEach(field => {
      field.selectedValue = "";
      field.selectedDate = "";
    });
    this.pageInfo.update(item => ({ ...item, filteredValue: this.filterFields.map(x => x.selectedValue) }));

  }

  // Method to filter options in each field based on filter text
  selectedFilters() {
    // console.log(this.filterFields.map(x => x.selectedValue));
    let selectedData = this.filterFields.filter(x => {
      const value = x.selectedValue;
      return value === 0 || !!value;
    });

    this.pageInfo.update(item => ({
      ...item, filteredValue: selectedData.map(x => {
        if (Array.isArray(x.selectedValue)) {
          return { [x.key]: x.selectedValue };
        }
        if(typeof x.selectedValue === "string") { return { [x.key]: [x.selectedValue.trim()] };}
        return ({ [x.key]: [x.selectedValue] });
      })
    }));
  }
  onFilterSelectChange(event, index) {
    console.log(event);
    if (this.filterFields[index].selectedValue) {
      this.filterFields[index]['selectedValue'].push(event._id);
    } else {
      this.filterFields[index]['selectedValue'] = [event._id];
    }
  }

  onFilterDeSelectChange(event, index) {
    console.log(event);
      let value  = this.filterFields[index]['selectedValue'];
      const index2 = value.indexOf(event._id);
      value.splice(index2, 1);
  }
}
